import * as React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Slide,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import { API } from "aws-amplify";
import { Alert } from "@material-ui/lab";
import BasicFieldsSection from "./BasicFieldsSection";
import DemographicProfileFieldsSection from "./DemographicProfileFieldsSection";
import CustomerResult from "./CustomerResult";
import { LoadingSpinner } from "../../../../utils/LoadingSpinner";
import { TransitionProps } from "@material-ui/core/transitions";
import CustomerWithContractSection from "./customer_type/CustomerWithContractComponent";
import {
  getDateOfBirth,
  getRandomDemographicInfo,
  getUniqueName,
} from "../../../../utils/RandomDemographicInfoGen";

const HEALTH_CHECK_URLS = {
  alpha: 'https://w.amazon.com/bin/view/Pharmacy/Public/Teams/PharmacySDET/ApaqPortalHealthCheckAlpha/',
  beta: 'https://w.amazon.com/bin/view/Pharmacy/Public/Teams/PharmacySDET/ApaqPortalHealthCheck/'
};

const styles = ({ spacing }: Theme) =>
  createStyles({
    alertCenter: {
      display: 'flex',
      justifyContent: 'center',
    },
    alertLink: {
      marginLeft: spacing(0.5),
      marginRight: spacing(0.5),
    },
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
  });

const TransitionConst = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

enum CreatePharmacyCustomerType {
  AMAZON_CUSTOMER,
  PHARMACY_CUSTOMER_WITHOUT_PASSCODE,
  PHARMACY_CUSTOMER_DEMOGRAPHIC_PROFILE,
  PHARMACY_CUSTOMER_WITH_HEALTH_PROFILE,
  PHARMACY_CUSTOMER_FOR_CHECKOUT,
  PHARMACY_CUSTOMER_WITH_ORDER,
  PHARMACY_CUSTOMER_WITH_CONTRACT,
}

interface ICustomerProps
  extends WithStyles<typeof styles>,
    RouteComponentProps {
  opt?: any;
}

interface ICustomerState {
  actorSubType: any;
  buttonVariantForPharmacyCustomer: any;
  buttonVariantForCheckout: any;
  buttonVariantForPharmacyCustomerWithContract: any;
  buttonVariantForPharmacyCustomerWithDemographicProfile: any;
  buttonVariantForPharmacyCustomerWithHealthProfile: any;
  buttonVariantForPharmacyCustomerWithoutPasscode: any;
  buttonVariantForPharmacyCustomerWithOrder: any;
  customer: any;
  demographicProfile: any;
  getPharmacyCustomer: boolean;
  healthProfile: any;
  identityValidationStatus: string;
  message: string;
  open: boolean;
  programName: any;
  randomDemographicInfo: any;
  rxPassForceActive: boolean;
  rxPassSubscription: boolean;
  hornbillSubscription: boolean;
  isDemographicProfile: boolean;
  showFieldsForPharmacyCustomer: boolean;
  showFieldsForPharmacyCustomerForCheckout: boolean;
  showFieldsForPharmacyCustomerWithContract: boolean;
  showFieldsForPharmacyCustomerWithDemographicProfile: boolean;
  showFieldsForPharmacyCustomerWithHealthProfile: boolean;
  showFieldsForPharmacyCustomerWithoutPasscode: boolean;
  showFieldsForPharmacyCustomerWithOrder: boolean;
  source: string;
  amazonAddressReady: boolean;
}

class CustomerSection extends React.Component<ICustomerProps, ICustomerState> {
  private basicFieldsSection: any;
  private demographicProfileFieldsSection: any;
  private customerWithContractSection: any;

  constructor(props: ICustomerProps) {
    super(props);
    this.state = {
      actorSubType: "ADULT",
      amazonAddressReady: false,
      buttonVariantForCheckout: "outlined",
      buttonVariantForPharmacyCustomer: "outlined",
      buttonVariantForPharmacyCustomerWithContract: "outlined",
      buttonVariantForPharmacyCustomerWithDemographicProfile: "outlined",
      buttonVariantForPharmacyCustomerWithHealthProfile: "outlined",
      buttonVariantForPharmacyCustomerWithOrder: "outlined",
      buttonVariantForPharmacyCustomerWithoutPasscode: "outlined",
      customer: "",
      demographicProfile: "",
      getPharmacyCustomer: true,
      healthProfile: "",
      identityValidationStatus: "VALIDATION_SUCCESS",
      message: "",
      open: false,
      programName: "WOLFGANG",
      randomDemographicInfo: "",
      rxPassForceActive: false,
      rxPassSubscription: false,
      hornbillSubscription: false,
      isDemographicProfile: false,
      showFieldsForPharmacyCustomer: false,
      showFieldsForPharmacyCustomerForCheckout: false,
      showFieldsForPharmacyCustomerWithContract: false,
      showFieldsForPharmacyCustomerWithDemographicProfile: false,
      showFieldsForPharmacyCustomerWithHealthProfile: false,
      showFieldsForPharmacyCustomerWithOrder: false,
      showFieldsForPharmacyCustomerWithoutPasscode: false,
      source: "MANUAL",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitForCheckout = this.handleSubmitForCheckout.bind(this);
    this.handleSubmitWithoutPasscode =
      this.handleSubmitWithoutPasscode.bind(this);
    this.handleSubmitWithDemographicProfile =
      this.handleSubmitWithDemographicProfile.bind(this);
    this.handleSubmitWithHealthProfile =
      this.handleSubmitWithHealthProfile.bind(this);
    this.handleSubmitWithOrder = this.handleSubmitWithOrder.bind(this);
    this.handleSubmitForContract = this.handleSubmitForContract.bind(this);
    this.handleProgramName = this.handleProgramName.bind(this);
    this.handleActorSubType = this.handleActorSubType.bind(this);
    this.handleIdentityValidationStatus =
      this.handleIdentityValidationStatus.bind(this);
    this.showFieldsForPharmacyCustomer =
      this.showFieldsForPharmacyCustomer.bind(this);
    this.showFieldsForPharmacyCustomerForCheckout =
      this.showFieldsForPharmacyCustomerForCheckout.bind(this);
    this.showFieldsForPharmacyCustomerWithoutPasscode =
      this.showFieldsForPharmacyCustomerWithoutPasscode.bind(this);
    this.showFieldsForPharmacyCustomerWithDemographicProfile =
      this.showFieldsForPharmacyCustomerWithDemographicProfile.bind(this);
    this.showFieldsForPharmacyCustomerWithHealthProfile =
      this.showFieldsForPharmacyCustomerWithHealthProfile.bind(this);
    this.showFieldsForPharmacyCustomerWithOrder =
      this.showFieldsForPharmacyCustomerWithOrder.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  public render() {
    return (
      <div style={{ flexGrow: 1 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs>
                <Alert severity="info" className={this.props.classes.alertCenter}>
                  <p>
                    ApaqPortal Health Check
                    <a className={this.props.classes.alertLink} href={HEALTH_CHECK_URLS.alpha} target="_blank" rel="noopener noreferrer">Alpha</a>
                    and
                    <a className={this.props.classes.alertLink} href={HEALTH_CHECK_URLS.beta} target="_blank" rel="noopener noreferrer">Beta</a>
                  </p>
                </Alert>
              </Grid>
            </Grid>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs>
                <Button
                  variant={this.state.buttonVariantForPharmacyCustomer}
                  color="default"
                  fullWidth
                  onClick={this.showFieldsForPharmacyCustomer}
                  style={{ padding: "3px" }}
                >
                  Amazon Customer
                </Button>
              </Grid>
              <Grid item xs>
                <Button
                  variant={
                    this.state.buttonVariantForPharmacyCustomerWithoutPasscode
                  }
                  color="default"
                  fullWidth
                  onClick={this.showFieldsForPharmacyCustomerWithoutPasscode}
                  style={{ padding: "3px" }}
                >
                  Pharmacy Customer Without Passcode
                </Button>
              </Grid>
              <Grid item xs>
                <Button
                  variant={
                    this.state
                      .buttonVariantForPharmacyCustomerWithDemographicProfile
                  }
                  color="default"
                  fullWidth
                  onClick={
                    this.showFieldsForPharmacyCustomerWithDemographicProfile
                  }
                  style={{ padding: "3px" }}
                >
                  Pharmacy Customer With Demographic Profile
                </Button>
              </Grid>
            </Grid>

            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={4}>
                <Button
                  variant={
                    this.state.buttonVariantForPharmacyCustomerWithHealthProfile
                  }
                  color="default"
                  fullWidth
                  onClick={this.showFieldsForPharmacyCustomerWithHealthProfile}
                  style={{ padding: "3px" }}
                >
                  Pharmacy Customer With Health Profile
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  variant={this.state.buttonVariantForCheckout}
                  color="default"
                  fullWidth
                  onClick={this.showFieldsForPharmacyCustomerForCheckout}
                  style={{ padding: "3px" }}
                >
                  Pharmacy Customer For Checkout
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  variant={this.state.buttonVariantForPharmacyCustomerWithOrder}
                  color="default"
                  fullWidth
                  onClick={this.showFieldsForPharmacyCustomerWithOrder}
                  style={{ padding: "3px" }}
                >
                  Pharmacy Customer With Order
                </Button>
              </Grid>
            </Grid>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={4}>
                <Button
                  variant={
                    this.state.buttonVariantForPharmacyCustomerWithContract
                  }
                  color="default"
                  fullWidth
                  onClick={() =>
                    this.showFields(
                      CreatePharmacyCustomerType.PHARMACY_CUSTOMER_WITH_CONTRACT
                    )
                  }
                  style={{ padding: "3px" }}
                >
                  Pharmacy Customer With Contract
                </Button>
              </Grid>
            </Grid>
          </Grid>

          {this.state.showFieldsForPharmacyCustomer && (
            <Grid item xs={12}>
              <BasicFieldsSection
                ref={(ref) => (this.basicFieldsSection = ref)}
                isAmazonCustomer={true}
                onAddressReadyChange={(ready) =>
                  this.setState({ amazonAddressReady: ready })
                }
              />
            </Grid>
          )}

          {this.state.showFieldsForPharmacyCustomer && (
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs>
                  <Button
                    variant="outlined"
                    color="default"
                    disabled={!this.state.amazonAddressReady}
                    onClick={this.handleSubmit}
                  >
                    Create Amazon Customer
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}

          {this.state.showFieldsForPharmacyCustomerWithoutPasscode && (
            <Grid item xs={12}>
              <BasicFieldsSection
                ref={(ref) => (this.basicFieldsSection = ref)}
              />
            </Grid>
          )}

          {this.state.showFieldsForPharmacyCustomerWithoutPasscode && (
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs>
                  <FormControl>
                    <InputLabel>Program Name (Required)</InputLabel>
                    <Select
                      value={this.state.programName}
                      style={{ width: 225 }}
                      onChange={this.handleProgramName}
                    >
                      <MenuItem value="WOLFGANG">
                        <em>WOLFGANG</em>
                      </MenuItem>
                      <MenuItem value="ZENO_TEST">
                        <em>ZENO_TEST</em>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Actor Sub Type</FormLabel>
                    <RadioGroup
                      aria-label="actorSubType"
                      value={this.state.actorSubType}
                      onChange={this.handleActorSubType}
                      style={{ width: 225 }}
                    >
                      <FormControlLabel
                        value="ADULT"
                        control={<Radio />}
                        label="ADULT"
                      />

                      {this.state.programName === "ZENO_TEST" && (
                        <FormControlLabel
                          value="CHILD"
                          control={<Radio />}
                          label="CHILD"
                        />
                      )}
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs>
                  <FormControl>
                    <InputLabel>
                      Identity Validation Status (Required)
                    </InputLabel>
                    <Select
                      value={this.state.identityValidationStatus}
                      onChange={this.handleIdentityValidationStatus}
                      style={{ width: 225 }}
                    >
                      <MenuItem value="VALIDATION_SUCCESS">Success</MenuItem>
                      <MenuItem value="VALIDATION_FAILED">Failed</MenuItem>
                      <MenuItem value="VALIDATION_NOT_AVAILABLE">
                        Not Available
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          )}

          {this.state.showFieldsForPharmacyCustomerWithoutPasscode && (
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs>
                  <Button
                    variant="outlined"
                    color="default"
                    onClick={this.handleSubmitWithoutPasscode}
                  >
                    Create Pharmacy Customer Without Passcode
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}

          {this.state.showFieldsForPharmacyCustomerWithDemographicProfile && (
            <DemographicProfileFieldsSection
              ref={(ref) => (this.demographicProfileFieldsSection = ref)}
              isDemographicProfile={this.state.isDemographicProfile}
            />
          )}

          {this.state.showFieldsForPharmacyCustomerWithDemographicProfile && (
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs>
                  <Button
                    variant="outlined"
                    color="default"
                    onClick={this.handleSubmitWithDemographicProfile}
                  >
                    Create Pharmacy Customer With Demographic Profile
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}

          {this.state.showFieldsForPharmacyCustomerWithHealthProfile && (
            <DemographicProfileFieldsSection
              ref={(ref) => (this.demographicProfileFieldsSection = ref)}
              healthProfile={
                this.state.showFieldsForPharmacyCustomerWithHealthProfile
              }
            />
          )}

          {this.state.showFieldsForPharmacyCustomerWithHealthProfile && (
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs>
                  <Button
                    variant="outlined"
                    color="default"
                    onClick={this.handleSubmitWithHealthProfile}
                  >
                    Create Pharmacy Customer With Health Profile
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}

          {this.state.showFieldsForPharmacyCustomerForCheckout && (
            <DemographicProfileFieldsSection
              ref={(ref) => (this.demographicProfileFieldsSection = ref)}
              forCheckout={this.state.showFieldsForPharmacyCustomerForCheckout}
            />
          )}

          {this.state.showFieldsForPharmacyCustomerForCheckout && (
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs>
                  <Button
                    variant="outlined"
                    color="default"
                    onClick={this.handleSubmitForCheckout}
                  >
                    Create Pharmacy Customer For Checkout
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}

          {this.state.showFieldsForPharmacyCustomerWithOrder && (
            <DemographicProfileFieldsSection
              ref={(ref) => (this.demographicProfileFieldsSection = ref)}
              forOrder={this.state.showFieldsForPharmacyCustomerWithOrder}
            />
          )}

          {this.state.showFieldsForPharmacyCustomerWithOrder && (
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs>
                  <Button
                    variant="outlined"
                    color="default"
                    onClick={this.handleSubmitWithOrder}
                  >
                    Create Pharmacy Customer With Order
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}

          {this.state.showFieldsForPharmacyCustomerWithContract && (
            <CustomerWithContractSection
              ref={(ref) => (this.customerWithContractSection = ref)}
            />
          )}

          {this.state.showFieldsForPharmacyCustomerWithContract && (
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs>
                  <Button
                    variant="outlined"
                    color="default"
                    onClick={this.handleSubmitForContract}
                  >
                    Create Pharmacy Customer With Contract
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12}>
            {!this.state.getPharmacyCustomer && <LoadingSpinner />}
            {this.state.customer && (
              <CustomerResult
                customer={this.state.customer}
                randomDemographicInfo={this.state.randomDemographicInfo}
                demographicProfile={this.state.demographicProfile}
                healthProfile={this.state.healthProfile}
                heading={"Pharmacy Customer"}
              />
            )}
          </Grid>

          {this.state.message && (
            <Dialog
              open={this.state.open}
              TransitionComponent={TransitionConst}
              keepMounted
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              onClose={this.handleClose}
            >
              <DialogTitle id="alert-dialog-slide-title">
                {"Exception occurred when creating pharmacy customer"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {this.state.message}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </Grid>
      </div>
    );
  }

  private handleClose() {
    this.setState({ open: false });
  }

  private showFields(createPharmacyCustomerType: CreatePharmacyCustomerType) {
    switch (createPharmacyCustomerType) {
      case CreatePharmacyCustomerType.AMAZON_CUSTOMER: {
        this.setState({ showFieldsForPharmacyCustomer: true });
        this.setState({ showFieldsForPharmacyCustomerWithoutPasscode: false });
        this.setState({
          showFieldsForPharmacyCustomerWithDemographicProfile: false,
        });
        this.setState({
          showFieldsForPharmacyCustomerWithHealthProfile: false,
        });
        this.setState({ showFieldsForPharmacyCustomerForCheckout: false });
        this.setState({ showFieldsForPharmacyCustomerWithOrder: false });
        this.setState({ showFieldsForPharmacyCustomerWithContract: false });

        this.setState({ buttonVariantForPharmacyCustomer: "contained" });
        this.setState({
          buttonVariantForPharmacyCustomerWithoutPasscode: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithDemographicProfile: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithHealthProfile: "outlined",
        });
        this.setState({ buttonVariantForCheckout: "outlined" });
        this.setState({
          buttonVariantForPharmacyCustomerWithOrder: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithContract: "outlined",
        });
        break;
      }
      case CreatePharmacyCustomerType.PHARMACY_CUSTOMER_WITHOUT_PASSCODE: {
        this.setState({ showFieldsForPharmacyCustomer: false });
        this.setState({ showFieldsForPharmacyCustomerWithoutPasscode: true });
        this.setState({
          showFieldsForPharmacyCustomerWithDemographicProfile: false,
        });
        this.setState({
          showFieldsForPharmacyCustomerWithHealthProfile: false,
        });
        this.setState({ showFieldsForPharmacyCustomerForCheckout: false });
        this.setState({ showFieldsForPharmacyCustomerWithOrder: false });
        this.setState({ showFieldsForPharmacyCustomerWithContract: false });

        this.setState({ buttonVariantForPharmacyCustomer: "outlined" });
        this.setState({
          buttonVariantForPharmacyCustomerWithoutPasscode: "contained",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithDemographicProfile: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithHealthProfile: "outlined",
        });
        this.setState({ buttonVariantForCheckout: "outlined" });
        this.setState({
          buttonVariantForPharmacyCustomerWithOrder: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithContract: "outlined",
        });
        break;
      }
      case CreatePharmacyCustomerType.PHARMACY_CUSTOMER_DEMOGRAPHIC_PROFILE: {
        this.setState({ showFieldsForPharmacyCustomer: false });
        this.setState({ showFieldsForPharmacyCustomerWithoutPasscode: false });
        this.setState({
          showFieldsForPharmacyCustomerWithDemographicProfile: true,
        });
        this.setState({
          showFieldsForPharmacyCustomerWithHealthProfile: false,
        });
        this.setState({ showFieldsForPharmacyCustomerForCheckout: false });
        this.setState({ showFieldsForPharmacyCustomerWithOrder: false });
        this.setState({ showFieldsForPharmacyCustomerWithContract: false });

        this.setState({ programName: "WOLFGANG" });
        this.setState({ actorSubType: "ADULT" });
        this.setState({ isDemographicProfile: true });

        this.setState({ buttonVariantForPharmacyCustomer: "outlined" });
        this.setState({
          buttonVariantForPharmacyCustomerWithoutPasscode: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithDemographicProfile: "contained",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithHealthProfile: "outlined",
        });
        this.setState({ buttonVariantForCheckout: "outlined" });
        this.setState({
          buttonVariantForPharmacyCustomerWithOrder: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithContract: "outlined",
        });
        break;
      }
      case CreatePharmacyCustomerType.PHARMACY_CUSTOMER_WITH_HEALTH_PROFILE: {
        this.setState({ showFieldsForPharmacyCustomer: false });
        this.setState({ showFieldsForPharmacyCustomerWithoutPasscode: false });
        this.setState({
          showFieldsForPharmacyCustomerWithDemographicProfile: false,
        });
        this.setState({ showFieldsForPharmacyCustomerWithHealthProfile: true });
        this.setState({ showFieldsForPharmacyCustomerForCheckout: false });
        this.setState({ showFieldsForPharmacyCustomerWithOrder: false });
        this.setState({ showFieldsForPharmacyCustomerWithContract: false });

        this.setState({ programName: "WOLFGANG" });
        this.setState({ actorSubType: "ADULT" });

        this.setState({ buttonVariantForPharmacyCustomer: "outlined" });
        this.setState({
          buttonVariantForPharmacyCustomerWithoutPasscode: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithDemographicProfile: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithHealthProfile: "contained",
        });
        this.setState({ buttonVariantForCheckout: "outlined" });
        this.setState({
          buttonVariantForPharmacyCustomerWithOrder: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithContract: "outlined",
        });
        break;
      }
      case CreatePharmacyCustomerType.PHARMACY_CUSTOMER_FOR_CHECKOUT: {
        this.setState({ showFieldsForPharmacyCustomer: false });
        this.setState({ showFieldsForPharmacyCustomerWithoutPasscode: false });
        this.setState({
          showFieldsForPharmacyCustomerWithDemographicProfile: false,
        });
        this.setState({
          showFieldsForPharmacyCustomerWithHealthProfile: false,
        });
        this.setState({ showFieldsForPharmacyCustomerForCheckout: true });
        this.setState({ showFieldsForPharmacyCustomerWithOrder: false });
        this.setState({ showFieldsForPharmacyCustomerWithContract: false });

        this.setState({ programName: "WOLFGANG" });
        this.setState({ actorSubType: "ADULT" });

        this.setState({ buttonVariantForPharmacyCustomer: "outlined" });
        this.setState({
          buttonVariantForPharmacyCustomerWithoutPasscode: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithDemographicProfile: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithHealthProfile: "outlined",
        });
        this.setState({ buttonVariantForCheckout: "contained" });
        this.setState({
          buttonVariantForPharmacyCustomerWithOrder: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithContract: "outlined",
        });
        break;
      }
      case CreatePharmacyCustomerType.PHARMACY_CUSTOMER_WITH_ORDER: {
        this.setState({ showFieldsForPharmacyCustomer: false });
        this.setState({ showFieldsForPharmacyCustomerWithoutPasscode: false });
        this.setState({
          showFieldsForPharmacyCustomerWithDemographicProfile: false,
        });
        this.setState({
          showFieldsForPharmacyCustomerWithHealthProfile: false,
        });
        this.setState({ showFieldsForPharmacyCustomerForCheckout: false });
        this.setState({ showFieldsForPharmacyCustomerWithOrder: true });
        this.setState({ showFieldsForPharmacyCustomerWithContract: false });

        this.setState({ programName: "WOLFGANG" });
        this.setState({ actorSubType: "ADULT" });

        this.setState({ buttonVariantForPharmacyCustomer: "outlined" });
        this.setState({
          buttonVariantForPharmacyCustomerWithoutPasscode: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithDemographicProfile: "outlined",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithHealthProfile: "outlined",
        });
        this.setState({ buttonVariantForCheckout: "outlined" });
        this.setState({
          buttonVariantForPharmacyCustomerWithOrder: "contained",
        });
        this.setState({
          buttonVariantForPharmacyCustomerWithContract: "outlined",
        });
        break;
      }
      case CreatePharmacyCustomerType.PHARMACY_CUSTOMER_WITH_CONTRACT: {
        this.setCustomerWithContractState();
        break;
      }
      default: {
        break;
      }
    }
    this.setStateToBlank();
  }

  private setStateToBlank() {
    this.setState({ customer: "" });
  }

  private showFieldsForPharmacyCustomer() {
    this.showFields(CreatePharmacyCustomerType.AMAZON_CUSTOMER);
  }

  private showFieldsForPharmacyCustomerWithoutPasscode() {
    this.showFields(
      CreatePharmacyCustomerType.PHARMACY_CUSTOMER_WITHOUT_PASSCODE
    );
  }

  private showFieldsForPharmacyCustomerWithDemographicProfile() {
    this.showFields(
      CreatePharmacyCustomerType.PHARMACY_CUSTOMER_DEMOGRAPHIC_PROFILE
    );
  }

  private showFieldsForPharmacyCustomerWithHealthProfile() {
    this.showFields(
      CreatePharmacyCustomerType.PHARMACY_CUSTOMER_WITH_HEALTH_PROFILE
    );
  }

  private showFieldsForPharmacyCustomerForCheckout() {
    this.showFields(CreatePharmacyCustomerType.PHARMACY_CUSTOMER_FOR_CHECKOUT);
  }

  private showFieldsForPharmacyCustomerWithOrder() {
    this.showFields(CreatePharmacyCustomerType.PHARMACY_CUSTOMER_WITH_ORDER);
  }

  private handleProgramName(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ programName: event.target.value });
  }

  private handleActorSubType(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ actorSubType: event.target.value });
  }

  private handleIdentityValidationStatus(
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) {
    this.setState({ identityValidationStatus: event.target.value });
  }

  private handleSubmit() {
    this.setState({ getPharmacyCustomer: false });

    const apiName = "ApaqPortalAPI";
    const path = "/pharmacy-customer/create";
    const config = {
      body: {
        creditCard: this.basicFieldsSection.getState().creditCard,
        emailPrefix: this.basicFieldsSection.getState().emailPrefix,
        giftCard: this.basicFieldsSection.getState().giftCard,
        giftCardBalance: this.basicFieldsSection.getState().giftCardBalance,
        name: this.basicFieldsSection.getState().name,
        phoneNumber: this.basicFieldsSection.getState().phone,
        prime: this.basicFieldsSection.getState().prime,
        // Blank falls back to the backend default (Seattle).
        residentialAddressId:
          this.basicFieldsSection.getState().residentialAddressId || undefined,
        source: this.state.source,
      },
      headers: {},
    };

    this.callAPI(apiName, path, config);
    this.setRandomDemographicInfoPropToEmpty();
    this.handleRandomDemographicInfo();
  }

  private handleRandomDemographicInfo() {
    this.setState({ randomDemographicInfo: getRandomDemographicInfo() });
  }

  private setRandomDemographicInfoPropToEmpty() {
    this.setState({ randomDemographicInfo: "" });
  }

  private callAPI(apiName: string, path: string, config: any) {
    this.setState({ customer: "" });

    API.post(apiName, path, config)
      .then((value: any) => {
        console.log(value);

        const demographicProfile = [];
        const healthProfile = [];

        if (value.profile != null) {
          for (const entry of value.profile) {
            if (entry.demographicProfile != null) {
              demographicProfile.push(entry.demographicProfile);
            }
            if (entry.healthProfile != null) {
              healthProfile.push(entry.healthProfile);
            }
          }
        }

        this.setState({ healthProfile });
        this.setState({ demographicProfile });
        this.setState({ customer: value });
        this.setState({ getPharmacyCustomer: true });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ getPharmacyCustomer: true });
        this.setState({ open: true });
        this.setState({ message: error.response.data.message });
      });

    this.setState({ getPharmacyCustomer: false });
  }

  private handleSubmitWithoutPasscode() {
    this.setState({ getPharmacyCustomer: false });

    const apiName = "ApaqPortalAPI";
    const path = "/pharmacy-customer/create";
    const config = {
      body: {
        actorSubType: this.state.actorSubType,
        creditCard: this.basicFieldsSection.getState().creditCard,
        emailPrefix: this.basicFieldsSection.getState().emailPrefix,
        giftCard: this.basicFieldsSection.getState().giftCard,
        giftCardBalance: this.basicFieldsSection.getState().giftCardBalance,
        identityValidationStatus: this.state.identityValidationStatus,
        name: this.basicFieldsSection.getState().name,
        phoneNumber: this.basicFieldsSection.getState().phone,
        prime: this.basicFieldsSection.getState().prime,
        profile: true,
        programName: this.state.programName,
        rxPassForceActive: this.basicFieldsSection.getState().rxPassForceActive,
        rxPassSubscription:
          this.basicFieldsSection.getState().rxPassSubscription,
        source: this.state.source,
      },
      headers: {},
    };

    this.callAPI(apiName, path, config);
    this.setRandomDemographicInfoPropToEmpty();
    this.handleRandomDemographicInfo();
  }

  private handleSubmitWithDemographicProfile() {
    this.setState({ getPharmacyCustomer: false });
    this.setRandomDemographicInfoPropToEmpty();

    const apiName = "ApaqPortalAPI";
    const path = "/pharmacy-customer/create";
    const config = {
      body: {
        actorSubType: this.state.actorSubType,
        creditCard: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().creditCard,
        customerJourneyType:
          this.demographicProfileFieldsSection.getState().customerJourneyType,
        dateOfBirth:
          this.demographicProfileFieldsSection.getState().dateOfBirth == ""
            ? getDateOfBirth(Math.random(), -1000)
            : this.demographicProfileFieldsSection.getState().dateOfBirth,
        demographicProfile: true,
        emailPrefix: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().emailPrefix,
        gender: this.demographicProfileFieldsSection.getState().gender,
        giftCard: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().giftCard,
        giftCardBalance: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().giftCardBalance,
        identityValidationForKatara:
          this.demographicProfileFieldsSection.getState()
            .identityValidationStatusKatara,
        identityValidationStatus:
          this.demographicProfileFieldsSection.getState()
            .identityValidationStatus,
        legalFirstName:
          this.demographicProfileFieldsSection.getState().legalFirstName == ""
            ? getUniqueName()
            : this.demographicProfileFieldsSection.getState().legalFirstName,
        legalLastName:
          this.demographicProfileFieldsSection.getState().legalLastName == ""
            ? getUniqueName()
            : this.demographicProfileFieldsSection.getState().legalLastName,
        middleName: this.demographicProfileFieldsSection.getState().middleName,
        name: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().name,
        phoneNumber: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().phone,
        prime: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().prime,
        programName: this.state.programName,
        residentialAddressId:
          this.demographicProfileFieldsSection.getState().residentialAddressId,
        rxPassForceActive: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().rxPassForceActive,
        rxPassSubscription: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().rxPassSubscription,
        hornbillSubscription: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().hornbillSubscription,
        setDefaultAddress:
          this.demographicProfileFieldsSection.getState().setDefaultAddress,
        source: this.state.source,
        ssn: this.demographicProfileFieldsSection.getState().ssn,
        suffix: this.demographicProfileFieldsSection.getState().suffix,
      },
      headers: {},
    };

    this.callAPI(apiName, path, config);
  }

  private handleSubmitWithHealthProfile() {
    this.setState({ getPharmacyCustomer: false });
    this.setRandomDemographicInfoPropToEmpty();

    const apiName = "ApaqPortalAPI";
    const path = "/pharmacy-customer/create";
    const config = {
      body: {
        actorSubType: this.state.actorSubType,
        addInsurancePlan: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().addInsurancePlan,
        binNumber: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().binNumber,
        binNumber2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().binNumber2,
        binNumber3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().binNumber3,
        cardHolderId: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().cardHolderId,
        cardHolderId2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().cardHolderId2,
        cardHolderId3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().cardHolderId3,
        commonAllergies: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().commonAllergies,
        commonHealthConditions: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().commonHealthConditions,
        creditCard: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().creditCard,
        customerJourneyType:
          this.demographicProfileFieldsSection.getState().customerJourneyType,
        dateOfBirth:
          this.demographicProfileFieldsSection.getState().dateOfBirth == ""
            ? getDateOfBirth(Math.random(), -1000)
            : this.demographicProfileFieldsSection.getState().dateOfBirth,
        emailPrefix: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().emailPrefix,
        gender: this.demographicProfileFieldsSection.getState().gender,
        giftCard: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().giftCard,
        giftCardBalance: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().giftCardBalance,
        groupNumber: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().groupNumber,
        groupNumber2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().groupNumber2,
        groupNumber3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().groupNumber3,
        healthProfile: true,
        identityValidationForKatara:
          this.demographicProfileFieldsSection.getState()
            .identityValidationStatusKatara,
        identityValidationStatus:
          this.demographicProfileFieldsSection.getState()
            .identityValidationStatus,
        insurancePlan: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().insurancePlan,
        legalFirstName:
          this.demographicProfileFieldsSection.getState().legalFirstName == ""
            ? getUniqueName()
            : this.demographicProfileFieldsSection.getState().legalFirstName,
        legalLastName:
          this.demographicProfileFieldsSection.getState().legalLastName == ""
            ? getUniqueName()
            : this.demographicProfileFieldsSection.getState().legalLastName,
        medicationList: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().medicationList,
        middleName: this.demographicProfileFieldsSection.getState().middleName,
        name: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().name,
        pcn: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().pcn,
        pcn2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().pcn2,
        pcn3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().pcn3,
        phoneNumber: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().phone,
        pregnantOrNursing:
          this.demographicProfileFieldsSection.getState().gender === "Female"
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getState().pregnantOrNursing
            : null,
        prime: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().prime,
        programName: this.state.programName,
        residentialAddressId:
          this.demographicProfileFieldsSection.getState().residentialAddressId,
        rxPassForceActive: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().rxPassForceActive,
        rxPassSubscription: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().rxPassSubscription,
        setDefaultAddress:
          this.demographicProfileFieldsSection.getState().setDefaultAddress,
        setInsuranceAsPrimary: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().setInsuranceAsPrimary,
        setInsuranceAsPrimary2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().setInsuranceAsPrimary2,
        setInsuranceAsPrimary3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().setInsuranceAsPrimary3,
        source: this.state.source,
        spi: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().spi,
        ssn: this.demographicProfileFieldsSection.getState().ssn,
        staleHealthProfile: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().staleHealthProfile,
        suffix: this.demographicProfileFieldsSection.getState().suffix,
      },
      headers: {},
    };

    this.callAPI(apiName, path, config);
  }

  private handleSubmitForCheckout() {
    this.setState({ getPharmacyCustomer: false });
    this.setRandomDemographicInfoPropToEmpty();

    const apiName = "ApaqPortalAPI";
    const path = "/pharmacy-customer/create";
    const config = {
      body: {
        actorSubType: this.state.actorSubType,
        addInsurancePlan: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().addInsurancePlan,
        binNumber: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().binNumber,
        binNumber2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().binNumber2,
        binNumber3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().binNumber3,
        cardHolderId: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().cardHolderId,
        cardHolderId2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().cardHolderId2,
        cardHolderId3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().cardHolderId3,
        commonAllergies: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().commonAllergies,
        commonHealthConditions: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().commonHealthConditions,
        completeScriptChase:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().completeScriptChase
            : null,
        creditCard: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().creditCard,
        customerJourneyType:
          this.demographicProfileFieldsSection.getState().customerJourneyType,
        dateOfBirth:
          this.demographicProfileFieldsSection.getState().dateOfBirth == ""
            ? getDateOfBirth(Math.random(), -1000)
            : this.demographicProfileFieldsSection.getState().dateOfBirth,
        daysSupply:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().daysSupply
            : null,
        dispenseDaysSupply:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().dispenseDaysSupply
            : null,
        dispenseQuantity:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().dispenseQuantity
            : null,
        emailPrefix: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().emailPrefix,
        expirationDate:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().expirationDate
            : null,
        fakeOutScriptChase:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().fakeOutScriptChase
            : null,
        forCheckout: true,
        gender: this.demographicProfileFieldsSection.getState().gender,
        giftCard: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().giftCard,
        giftCardBalance: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().giftCardBalance,
        groupNumber: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().groupNumber,
        groupNumber2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().groupNumber2,
        groupNumber3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().groupNumber3,
        hoaAndCadence: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getCheckoutFieldsSection()
          .getState().hoaAndCadence,
        identityValidationForKatara:
          this.demographicProfileFieldsSection.getState()
            .identityValidationStatusKatara,
        identityValidationStatus:
          this.demographicProfileFieldsSection.getState()
            .identityValidationStatus,
        initialRefills:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().refillsAuthorized
            : null,
        initiateScriptChase:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().initiateScriptChase
            : null,
        insurancePlan: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().insurancePlan,
        legalFirstName:
          this.demographicProfileFieldsSection.getState().legalFirstName == ""
            ? getUniqueName()
            : this.demographicProfileFieldsSection.getState().legalFirstName,
        legalLastName:
          this.demographicProfileFieldsSection.getState().legalLastName == ""
            ? getUniqueName()
            : this.demographicProfileFieldsSection.getState().legalLastName,
        medicationList: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().medicationList,
        middleName: this.demographicProfileFieldsSection.getState().middleName,
        name: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().name,
        oneTimeFillReason:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().oneTimeFillReason
            : null,
        pcn: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().pcn,
        pcn2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().pcn2,
        pcn3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().pcn3,
        phoneNumber: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().phone,
        pregnantOrNursing:
          this.demographicProfileFieldsSection.getState().gender === "Female"
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getState().pregnantOrNursing
            : null,
        prime: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().prime,
        programName: this.state.programName,
        quantityAuthorized:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().quantityAuthorized
            : null,
        quantityPerDay: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getCheckoutFieldsSection()
          .getState().quantityPerDay,
        quantityPerDose: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getCheckoutFieldsSection()
          .getState().quantityPerDose,
        residentialAddressId:
          this.demographicProfileFieldsSection.getState().residentialAddressId,
        rxPassForceActive: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().rxPassForceActive,
        rxPassSubscription: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().rxPassSubscription,
        setDefaultAddress:
          this.demographicProfileFieldsSection.getState().setDefaultAddress,
        setDefaultPaymentMethod:
          this.demographicProfileFieldsSection.getState()
            .setDefaultPaymentMethod,
        setInsuranceAsPrimary: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().setInsuranceAsPrimary,
        setInsuranceAsPrimary2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().setInsuranceAsPrimary2,
        setInsuranceAsPrimary3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().setInsuranceAsPrimary3,
        source: this.state.source,
        spi: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().spi,
        ssn: this.demographicProfileFieldsSection.getState().ssn,
        staleHealthProfile: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().staleHealthProfile,
        status:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().status
            : null,
        suffix: this.demographicProfileFieldsSection.getState().suffix,
      },
      headers: {},
    };

    this.callAPI(apiName, path, config);
  }

  private handleSubmitWithOrder() {
    this.setState({ getPharmacyCustomer: false });
    this.setRandomDemographicInfoPropToEmpty();

    const apiName = "ApaqPortalAPI";
    const path = "/pharmacy-customer/create";
    const config = {
      body: {
        actorSubType: this.state.actorSubType,
        addInsurancePlan: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().addInsurancePlan,
        binNumber: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().binNumber,
        binNumber2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().binNumber2,
        binNumber3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().binNumber3,
        cardHolderId: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().cardHolderId,
        cardHolderId2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().cardHolderId2,
        cardHolderId3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().cardHolderId3,
        commonAllergies: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().commonAllergies,
        commonHealthConditions: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().commonHealthConditions,
        completeScriptChase:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().completeScriptChase
            : null,
        createOrder: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getCheckoutFieldsSection()
          .getOrderFieldsSection()
          .getState().createOrder,
        createOrderPaymentMethod: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getCheckoutFieldsSection()
          .getOrderFieldsSection()
          .getState().createOrderPaymentMethod,
        createOrderType: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getCheckoutFieldsSection()
          .getOrderFieldsSection()
          .getState().createOrderType,
        creditCard: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().creditCard,
        customerJourneyType:
          this.demographicProfileFieldsSection.getState().customerJourneyType,
        dateOfBirth:
          this.demographicProfileFieldsSection.getState().dateOfBirth == ""
            ? getDateOfBirth(Math.random(), -1000)
            : this.demographicProfileFieldsSection.getState().dateOfBirth,
        daysSupply:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().daysSupply
            : null,
        dispenseDaysSupply:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().dispenseDaysSupply
            : null,
        dispenseQuantity:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().dispenseQuantity
            : null,
        emailPrefix: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().emailPrefix,
        expirationDate:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().expirationDate
            : null,
        fakeOutScriptChase:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().fakeOutScriptChase
            : null,
        forCheckout: true,
        gender: this.demographicProfileFieldsSection.getState().gender,
        giftCard: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().giftCard,
        giftCardBalance: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().giftCardBalance,
        groupNumber: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().groupNumber,
        groupNumber2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().groupNumber2,
        groupNumber3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().groupNumber3,
        hoaAndCadence: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getCheckoutFieldsSection()
          .getState().hoaAndCadence,
        identityValidationForKatara:
          this.demographicProfileFieldsSection.getState()
            .identityValidationStatusKatara,
        identityValidationStatus:
          this.demographicProfileFieldsSection.getState()
            .identityValidationStatus,
        initialRefills:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().refillsAuthorized
            : null,
        initiateScriptChase:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().initiateScriptChase
            : null,
        insurancePlan: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().insurancePlan,
        legalFirstName:
          this.demographicProfileFieldsSection.getState().legalFirstName == ""
            ? getUniqueName()
            : this.demographicProfileFieldsSection.getState().legalFirstName,
        legalLastName:
          this.demographicProfileFieldsSection.getState().legalLastName == ""
            ? getUniqueName()
            : this.demographicProfileFieldsSection.getState().legalLastName,
        medicationList: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().medicationList,
        middleName: this.demographicProfileFieldsSection.getState().middleName,
        name: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().name,
        oneTimeFillReason:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().oneTimeFillReason
            : null,
        pcn: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().pcn,
        pcn2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().pcn2,
        pcn3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().pcn3,
        phoneNumber: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().phone,
        pregnantOrNursing:
          this.demographicProfileFieldsSection.getState().gender === "Female"
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getState().pregnantOrNursing
            : null,
        prime: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().prime,
        programName: this.state.programName,
        quantityAuthorized:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().quantityAuthorized
            : null,
        quantityPerDay: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getCheckoutFieldsSection()
          .getState().quantityPerDay,
        quantityPerDose: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getCheckoutFieldsSection()
          .getState().quantityPerDose,
        residentialAddressId:
          this.demographicProfileFieldsSection.getState().residentialAddressId,
        rxPassForceActive: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().rxPassForceActive,
        rxPassSubscription: this.demographicProfileFieldsSection
          .getBasicFieldsSection()
          .getState().rxPassSubscription,
        setDefaultAddress:
          this.demographicProfileFieldsSection.getState().setDefaultAddress,
        setInsuranceAsPrimary: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().setInsuranceAsPrimary,
        setInsuranceAsPrimary2: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().setInsuranceAsPrimary2,
        setInsuranceAsPrimary3: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().setInsuranceAsPrimary3,
        source: this.state.source,
        spi: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().spi,
        ssn: this.demographicProfileFieldsSection.getState().ssn,
        staleHealthProfile: this.demographicProfileFieldsSection
          .getHealthProfileFieldsSection()
          .getState().staleHealthProfile,
        status:
          this.demographicProfileFieldsSection
            .getHealthProfileFieldsSection()
            .getState().medicationList.length > 0
            ? this.demographicProfileFieldsSection
                .getHealthProfileFieldsSection()
                .getCheckoutFieldsSection()
                .getState().status
            : null,
        suffix: this.demographicProfileFieldsSection.getState().suffix,
      },
      headers: {},
    };

    // Validation (todo: remove once the subcomponents can update basic fields [after re-architecture])
    if (
      config.body.createOrderPaymentMethod === "giftCard" &&
      config.body.giftCard === false
    ) {
      const msg =
        "Gift Card is required to create a Gift Card Order:" +
        " Please set the Gift Card checkbox in the Basic Fields section.";
      console.log(msg);
      this.setState({ getPharmacyCustomer: true });
      this.setState({ open: true });
      this.setState({ message: msg });
    } else if (
      config.body.createOrderPaymentMethod === "cash" &&
      config.body.creditCard === false
    ) {
      const msg =
        "Credit Card is required to create a Cash Order:" +
        " Please set the Credit Card checkbox in the Basic Fields section.";
      console.log(msg);
      this.setState({ getPharmacyCustomer: true });
      this.setState({ open: true });
      this.setState({ message: msg });
    } else {
      this.callAPI(apiName, path, config);
    }
  }

  private handleSubmitForContract() {
    this.setState({ getPharmacyCustomer: false });
    this.setRandomDemographicInfoPropToEmpty();

    const apiName = "ApaqPortalAPI";
    const path = "/pharmacy-customer/create";
    const config = this.customerWithContractSection.getRequest();

    this.callAPI(apiName, path, config);
  }

  private setCustomerWithContractState() {
    this.setState({ showFieldsForPharmacyCustomer: false });
    this.setState({ showFieldsForPharmacyCustomerWithoutPasscode: false });
    this.setState({
      showFieldsForPharmacyCustomerWithDemographicProfile: false,
    });
    this.setState({ showFieldsForPharmacyCustomerWithHealthProfile: false });
    this.setState({ showFieldsForPharmacyCustomerForCheckout: false });
    this.setState({ showFieldsForPharmacyCustomerWithOrder: false });
    this.setState({ showFieldsForPharmacyCustomerWithContract: true });

    this.setState({ programName: "WOLFGANG" });
    this.setState({ actorSubType: "ADULT" });

    this.setState({ buttonVariantForPharmacyCustomer: "outlined" });
    this.setState({
      buttonVariantForPharmacyCustomerWithoutPasscode: "outlined",
    });
    this.setState({
      buttonVariantForPharmacyCustomerWithDemographicProfile: "outlined",
    });
    this.setState({
      buttonVariantForPharmacyCustomerWithHealthProfile: "outlined",
    });
    this.setState({ buttonVariantForCheckout: "outlined" });
    this.setState({ buttonVariantForPharmacyCustomerWithOrder: "outlined" });
    this.setState({
      buttonVariantForPharmacyCustomerWithContract: "contained",
    });
  }
}

export default withStyles(styles)(CustomerSection);
